let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fkQ12"), load("daCl8"), load("aZinD"), load("6qah4"), load("joJy8"), load("aHE9G"), load("9QyoN")]).then(() => parcelRequire('bm1ob'));